<template>
  <div class="login-outer-container">
    <div class="center-middle overflow-container">
      <div class="middle-container">
        <img
          class="top-logo"
          v-if="company.login_top"
          :src="company.login_top"
          :alt="$t(`global.${company.name}`)"
        />
        <Card :disableTitle="true">
          <div class="loader-area" v-if="isLoading">
            <loading-state :size="50" />
          </div>
          <div v-else class="login-container">
            <SignupForm @success="gotohome" :longform="false" />
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import Card from "@/components/display/Card";
import constants from "@/utils/constants";
import i8n from "@/i18n";
import LoadingState from "@/components/display/LoadingState";
import SignupForm from "@/components/smart/forms/SignupForm";
import store from "@/store";
import useCompany from "../utils/useCompany";

export default {
  name: "SignupPage",
  components: {
    Card,
    LoadingState,
    SignupForm,
  },
  props: {
    redirect: String,
    reason: String,
  },
  setup(props, { root }) {
    const isLoading = computed(() => {
      return store.state.settings.status.isLoading;
    });

    // reasons for being directed to the login page
    const reasons = {
      "successful-password-reset": i8n.t("toasts.successfully-requested-password-reset"),
      "successful-password-request": i8n.t("toasts.successfully-requested-password-request"),
    };

    onMounted(() => {
      const displayReason = reasons[props.reason];
      // if a reason has been provided, show a toast for it
      if (displayReason) {
        store.dispatch("toasts/addToast", {
          message: displayReason,
        });
      }
      store.dispatch("settings/fetch");
    });

    const { company } = useCompany();

    const gotohome = () => {
      if (props.redirect) {
        root.$router.push(decodeURI(props.redirect));
      } else {
        root.$router.push({ name: constants.HOME_ROUTE });
      }
    };

    return {
      gotohome,
      company,
      isLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";

.login-outer-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .overflow-container {
    overflow: auto;
    padding: 1rem 0;
  }
  .middle-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 100%;
    max-width: 360px;
    padding: 1rem;
  }
  .top-logo {
    max-width: 100%;
    width: 350px;
    margin-bottom: 1rem;
    text-align: center;
  }

  .loader-area {
    width: 100%;
    min-width: 300px;
    max-width: 350px;
    height: 350px;
    position: relative;
  }

  .login-container {
    min-width: 300px;
    padding: 1rem;

    .form-control {
      width: 100%;
    }
  }
}
</style>
